import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Spinplay} from '../shared/spinplay';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class QuarantineService {

  musicPointUrl: string = environment.dashboardApiUrl;

  getQuarantined(): Observable<Array<Spinplay>> {
    const url = this.musicPointUrl + '/quarantined';
    return this.http.get<Array<Spinplay>>(url);
  }
  approveQuarantine(spinPlay: Spinplay): Observable<void>  {
    const url = this.musicPointUrl + '/quarantined/approve';
    return this.http.post<any>(url, spinPlay);
  }
  hideQuarantine(entityInstanceId: number): Observable<void> {
    const url = this.musicPointUrl + '/quarantined/hide';
    return this.http.post<any>(url, entityInstanceId);
  }
  constructor( private http: HttpClient ) { }

}



// WEBPACK FOOTER //
// ./src/app/quarantine/quarantine.service.ts